
import { SellersApiRemoteService } from '../../Services/api/sellers/sellers-service'
import { IListSellersPayload, ISellersListResponse } from '../../Services/api/sellers/sellers.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class ListSellersUseCase
implements IFormUsecase<IListSellersPayload, ISellersListResponse> {
  constructor (private readonly SellersApi: SellersApiRemoteService) {}
    

  public async handle (
    data: IListSellersPayload
  ): Promise<Result<ISellersListResponse>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.SellersApi.list(data)

      if (response.isFailure) {
        return response
      }
    
      const list = response.getValue()

      if(!list) return response
    
      return Result.ok(list)
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
